import { useEffect } from "react"

import { useWelcomeModalStore } from "../components/modals/WelcomeModal"
import { localStorageItems } from "../util/storage"

export const useShowWelcomeModal = () => {
  const { onOpen: openWelcomeModal } = useWelcomeModalStore()

  useEffect(() => {
    const needsToSeeWelcomeModal = localStorage.getItem(
      localStorageItems.needsToSeeWelcomeModal
    )
    if (!needsToSeeWelcomeModal) return
    openWelcomeModal()
  }, [openWelcomeModal])
}
